'use es6';

import importAdapter from './importAdapter';
import associationDefinitionsAdapter from './associationDefinitionsAdapter';
import standardObjectDefinitionsAdapter from './standardObjectDefinitionsAdapter';
import customObjectDefinitionsAdapter from './customObjectDefinitionsAdapter';
import customObjectPropertiesAdapter from './customObjectPropertiesAdapter';
import unifiedEventAdapter from './unifiedEventAdapter';
import unifiedEventPropertiesAdapter from './unifiedEventPropertiesAdapter';
import referenceResolverAdapter, { configureComponent } from './referenceResolverAdapter';
import customBehavioralEventAdapter from './customBehavioralEventAdapter';
import customBehavioralEventPropertiesAdapter from './customBehavioralEventPropertiesAdapter';
import appObjectDefinitionsAdapter from './appObjectDefinitionsAdapter';
import appObjectPropertiesAdapter from './appObjectPropertiesAdapter';
export const withDefaultAdapters = configureComponent;

// Order here is important, the last element in this array with have the
// least amount of precedence when it comes to picking an adapter to fetch with
export default [standardObjectDefinitionsAdapter, importAdapter, customBehavioralEventAdapter, customBehavioralEventPropertiesAdapter, unifiedEventAdapter, unifiedEventPropertiesAdapter, customObjectDefinitionsAdapter, associationDefinitionsAdapter, customObjectPropertiesAdapter, referenceResolverAdapter, appObjectDefinitionsAdapter, appObjectPropertiesAdapter];